export function logout() {
  console.log("logged out");
  localStorage.removeItem("user");
  window.location.reload();
}
